<template>
  <h3 class="pb5">Repérages (5 et plus) autoexclusions (par numéro) (CDX 0010)</h3>
  <CritereRechercheReperages ref="critereRechercheReperages"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import CritereRechercheReperages from "@/components/rapports/Rechercher/CritereRechercheReperages.vue";

export default {
  name: "DossiersReperages5PlusAutoexclusionNumero",
  components: {CritereRechercheReperages, ButtonBar},
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Repérage");
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$store.dispatch("narration/rechercherDefaut48HeuresAction")
        .then((res) => {
          this.assignerResultat(res);
        });
  },
  methods: {
    assignerResultat(res) {
      if (res.data.entites !== null)
        this.$refs.critereRechercheReperages.assignerListe(res.data.entiteDecision);
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      var criteresRapportVO = this.$refs.critereRechercheReperages.getCritereRecherche();
      criteresRapportVO.titre = "DossiersReperages5PlusAutoexclusionNumero";
      criteresRapportVO.nomRapport = "NumeroPlus5ReperageAutoexclusionGenerateurRapport_CDX_0010";
      this.$store.dispatch("rapports/obtenirRapportAction",
          criteresRapportVO
      )
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
}
</script>

